import React from 'react';
import { Location } from '../../../location/LocationStep';
import LocationCard from './LocationCard';
import LocationList from './LocationList';

interface LocationDisplayProps {
  locations: { node: Location }[];
  selectedLocations: Location | Location[] | null;
  onLocationClick: (location: Location) => void;
  isClickable: boolean;
  nodeData: any;
}

const LocationDisplay: React.FC<LocationDisplayProps> = ({
  locations,
  selectedLocations,
  onLocationClick,
  isClickable,
  nodeData
}) => {

  // Extract settings from nodeData or use defaults
  const settings = nodeData?.settings || {
    showMap: true,
    displayStyle: 'cards',
    itemsPerRow: 2,
    numberRows: 2,
    colors: {}
  };

  // Extract colors from settings
  const colors = settings?.colors || {};

  // Determine which component to render based on displayStyle
  if (settings.displayStyle === 'cards') {
    return (
      <LocationCard
        locations={locations}
        selectedLocations={selectedLocations}
        onLocationClick={onLocationClick}
        isClickable={isClickable}
        showMap={settings.showMap}
        colors={colors}
        itemsPerRow={settings.itemsPerRow || 2}
      />
    );
  } else {
    // For 'list' or any other display style
    return (
      <LocationList
        locations={locations}
        selectedLocations={selectedLocations}
        onLocationClick={onLocationClick}
        isClickable={isClickable}
        colors={colors}
      />
    );
  }
};

export default LocationDisplay;
